import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get('/settings/public').then(r => setSettings(r.data)).catch(() => {}); }, []);

  const siteName = settings?.site_name || 'Astha Abhyas';
  const contactEmail = settings?.contact_email || 'support@asthaabhyas.com';
  const contactPhone = settings?.contact_phone;

  return (
    <footer className="bg-[#0A0A0A] text-zinc-400 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              {settings?.footer_logo_url ? (
                <img src={settings.footer_logo_url} alt={siteName} className="h-9 w-auto max-w-[160px] object-contain" />
              ) : (
                <>
                  <div className="w-8 h-8 rounded-lg bg-[#7551e8] flex items-center justify-center">
                    <span className="text-white font-bold font-['Outfit']">A</span>
                  </div>
                  <span className="font-['Outfit'] font-semibold text-lg text-white">{siteName}</span>
                </>
              )}
            </div>
            <p className="text-sm leading-relaxed">Your gateway to exam success. Practice, analyze, and achieve your goals.</p>
          </div>
          <div>
            <h4 className="text-white font-['Outfit'] font-medium mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm hover:text-[#7551e8] transition-colors">Home</Link>
              <Link to="/dashboard" className="block text-sm hover:text-[#7551e8] transition-colors">Dashboard</Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-['Outfit'] font-medium mb-4">Legal</h4>
            <div className="space-y-2">
              <Link to="/page/privacy-policy" className="block text-sm hover:text-[#7551e8] transition-colors">Privacy Policy</Link>
              <Link to="/page/terms-and-conditions" className="block text-sm hover:text-[#7551e8] transition-colors">Terms & Conditions</Link>
              <Link to="/page/contact-us" className="block text-sm hover:text-[#7551e8] transition-colors">Contact Us</Link>
              <Link to="/page/about-us" className="block text-sm hover:text-[#7551e8] transition-colors">About Us</Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-['Outfit'] font-medium mb-4">Contact</h4>
            <p className="text-sm">{contactEmail}</p>
            {contactPhone && <p className="text-sm mt-1">{contactPhone}</p>}
            <div className="flex gap-3 mt-3">
              {settings?.social_facebook && <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#7551e8] transition-colors">Facebook</a>}
              {settings?.social_twitter && <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#7551e8] transition-colors">Twitter</a>}
              {settings?.social_instagram && <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#7551e8] transition-colors">Instagram</a>}
            </div>
          </div>
        </div>
        <div className="border-t border-zinc-800 mt-8 pt-6 text-center text-xs">
          &copy; {new Date().getFullYear()} {siteName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
